export const viewerNeededMimeTypes = [
  'application/msword', // .doc || .dot
  'application/vnd.ms-excel.addin.macroEnabled.12', //.xlam
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // .xlsb
  'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm
  'application/vnd.ms-excel.template.macroEnabled.12', // .xltm
  'application/vnd.ms-excel', // .xls || .xlt || .xlan",
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template', // .xltx
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx # noqa: E501
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template', // .dotx # noqa: E501
];

export const externalContentViewerPrefix =
  'https://view.officeapps.live.com/op/embed.aspx?src=';

export const externalContentUri = ({
  mimeType,
  uri,
}: {
  mimeType: string;
  uri: string;
}) => {
  const prefix = viewerNeededMimeTypes.includes(mimeType)
    ? externalContentViewerPrefix
    : '';
  return `${prefix}${uri}`;
};
